
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable'
import ModalDialog from '@/components/modals/ModalDialog.vue'

import StatusRow from './email/Row.vue'
import LanguagesSelect from './email/LanguagesSelect.vue'

@Component({
  name: 'EmailScene',
  components: {
    draggable,
    StatusRow,
    ModalDialog,
    LanguagesSelect
  },
})
export default class EmailScene extends Vue {
  @Prop() readonly vacancyId: string;

  private inviteTemplatesOpened = true;
  private remindTemplateOpened = true;
  private onTop = false;
  private drag = false;
  private addNewStatus = false;
  private templatesIsClosed = [];
  private nextRoute = null;
  private language = null;

  get statuses () {
    return this.$store.getters['dictionary/responseStatuses']
  };

  get statusesBase () {
    if (!this.statuses) {
      return []
    }

    return this.statuses.filter(status => status.is_base)
  };

  get statusesOther () {
    if (!this.statuses) {
      return []
    }

    return this.statuses.filter(status => !status.is_base)
  };

  get templates () {
    return this.$store.getters['vacancy/emailTemplatesDefault'].filter((template) => {
      if (!template.language) {
        return false
      }

      const lang = this.language && this.language.code ? this.language.code : this.currentLocale

      return template.language.code === lang
    })
  };

  get templatesDefault () {
    if (!this.templates || !this.templates.length) {
      return []
    }

    return this.templates.filter(template => template.is_standard)
  };

  get templatesCustom () {
    if (!this.templates || !this.templates.length) {
      return []
    }

    return this.templates
      .filter(template => !template.is_standard)
      .filter(template => template.response_status)
  };

  get templatesCustomWithoutStatus () {
    if (!this.templates || !this.templates.length) {
      return []
    }

    return this.templates
      .filter(template => !template.is_standard)
      .filter(template => !template.response_status)
  };

  get currentLocale () {
    return this.$store.state.locale.value
  };

  get languages () {
    return [
      {
        id: 1,
        code: 'en',
        name: 'English'
      },
      {
        id: 2,
        code: 'ru',
        name: 'Русский'
      },
      {
        id: 3,
        code: 'ja',
        name: '日本語'
      }
    ]
  };

  @Watch('templates', {
    immediate: true
  })
  templatesChanged(val) {
    this.templatesIsClosed = val.map((template) => {
      return {
        id: template.id,
        isClosed: true
      }
    })
  };

  public fetch () {
    this.$store.dispatch('dictionary/fetch', true)
    this.$store.dispatch('vacancy/getEmailTemplatesDefault')
  };

  public setDefaultLanguage () {
    if (this.currentLocale === 'ru') {
      this.language = this.languages[1]
    } else {
      this.language = this.languages[0]
    }
  };

  public templateIsClosed (id) {
    if (!id || !this.templates || !this.templatesIsClosed) {
      return null
    }

    return this.templatesIsClosed.find(item => item.id === id)
  };

  public endDrag (ev) {
    this.drag = false

    this.$store.dispatch('dictionary/updateResponseStatusesPriority', {
      statuses: this.statuses,
      fromIndex: Math.min(ev.newIndex, ev.oldIndex)
    })
  };

  public addTemplate () {
    const newTemplatesIsClosed = this.templatesIsClosed.map(item => {
      item.isClosed = true
      return item
    })
    this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed)

    setTimeout(() => {
      this.addNewStatus = true
    }, 100)
  };

  public hideAddAndEditMode (id) {
    let newTemplatesIsClosed = this.templatesIsClosed.map(item => {
      item.isClosed = true
      return item
    })
    this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed)

    setTimeout(() => {
      if (id) {
        newTemplatesIsClosed = this.templatesIsClosed.map(item => {
          item.isClosed = item.id !== id
          return item
        })
        this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed)
      }
    }, 100)

    this.addNewStatus = false
  };

  public cancelEditMode () {
    const newTemplatesIsClosed = this.templatesIsClosed.map(item => {
      item.isClosed = true
      return item
    })
    this.templatesIsClosed.splice(0, this.templatesIsClosed.length, ...newTemplatesIsClosed)

    setTimeout(() => {
      this.addNewStatus = false
    }, 100)
  };

  beforeMount () {
    this.fetch()
    this.setDefaultLanguage()
  }
}
